/* eslint-disable */
import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
// import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { Tab, TabContainer } from "@saleor/components/Tab";
// import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
// import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { sectionNames } from "@saleor/intl";
// import { SearchCornermarks_search_edges_node } from "@saleor/searches/types/SearchCornermarks";
// import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import React from "react";
import { useIntl } from "react-intl";

import {
  maybe
  // splitDateTime
} from "../../../misc";
import {
  // FetchMoreProps,
  ListProps2,
  TabListActions
} from "../../../types";
// import { SaleType as SaleTypeEnum } from "../../../types/globalTypes";
import { Producttag_producttag } from "../../types/Producttag";
import DiscountCategories from "../DiscountCategories";
import DiscountCollections from "../DiscountCollections";
// import DiscountDates from "../DiscountDates";
import DiscountProducts from "../DiscountProducts";
// import DiscountSaleProducts from "../DiscountSaleProducts";
import DiscountVariants from "../DiscountVariants";
import { UpdateProducttags_producttagsUpdate_errors } from "@saleor/producttags/types/UpdateProducttags";
import ProductTagInfo from "../ProductTagInfo";
import { ProductTagsTagType } from "@saleor/types/globalTypes";
// import SaleCornermarks from "../SaleCornermarks";
// import SaleInfo from "../SaleInfo";
// import SaleSummary from "../SaleSummary";
// import SaleType from "../SaleType";
// import SaleValue from "../SaleValue";

// interface ProductsData {
//   productId: string;
//   usageLimit: number;
//   discountPrice: string;
//   sortOrder: any;
// }

export interface ProductTagDetailsPageFormData {
  // endDate: string;
  // endTime: string;
  // hasEndDate: boolean;
  title: string;
  name: string;
  tagType: ProductTagsTagType;
  stickersImage: string;
  stickersImageLocationX: number;
  stickersImageLocationY: number;
  showTag: boolean;
  componentFontColor?: string;
  productFontColor?: string;
  productBackgroundColor?: string;

  // startDate: string;
  // startTime: string;
  // type: SaleTypeEnum;
  // value: string;
  // products?: ProductsData[];
  // cornerMark: string;
}

export enum ProductTageDetailsPageTab {
  categories = "categories",
  collections = "collections",
  products = "products",
  variants = "variants"
  // saleProducts = "saleProducts"
}
export function saleDetailsPageTab(tab: string): ProductTageDetailsPageTab {
  return tab === ProductTageDetailsPageTab.variants
    ? ProductTageDetailsPageTab.variants
    : tab === ProductTageDetailsPageTab.products
    ? ProductTageDetailsPageTab.products
    : tab === ProductTageDetailsPageTab.collections
    ? ProductTageDetailsPageTab.collections
    : ProductTageDetailsPageTab.categories;
}

export interface SaleDetailsPageProps
  extends Pick<ListProps2, Exclude<keyof ListProps2, "onRowClick">>,
    TabListActions<
      | "categoryListToolbar"
      | "collectionListToolbar"
      | "productListToolbar"
      | "variantListToolbar"
    > {
  activeTab: ProductTageDetailsPageTab;
  // defaultCurrency?: string;
  errors: UpdateProducttags_producttagsUpdate_errors[];
  Producttag: Producttag_producttag;
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  // cornermarks?: SearchCornermarks_search_edges_node[];
  onCategoryAssign: () => void;
  onCategoryUnassign: (id: string) => void;
  onCategoryClick: (id: string) => () => void;
  onCollectionAssign: () => void;
  onCollectionUnassign: (id: string) => void;
  onCollectionClick: (id: string) => () => void;
  onProductAssign: () => void;
  onProductUnassign: (id: string) => void;
  onProductClick: (id: string) => () => void;
  onVariantAssign: () => void;
  onVariantUnassign: (id: string) => void;
  onVariantClick: (productId: string, variantId: string) => () => void;
  onRemove: () => void;
  onSubmit: (data: ProductTagDetailsPageFormData) => void;
  onTabClick: (index: ProductTageDetailsPageTab) => void;
  // onSaleProductAssign: () => void;
  // onSaleProductUnassign: (id: string) => void;
  // fetchCornermarks?: (data: string) => void;
  // fetchMoreCornermarks?: FetchMoreProps;
}

const CategoriesTab = Tab(ProductTageDetailsPageTab.categories);
const CollectionsTab = Tab(ProductTageDetailsPageTab.collections);
const ProductsTab = Tab(ProductTageDetailsPageTab.products);
const VariantsTab = Tab(ProductTageDetailsPageTab.variants);

const SaleDetailsPage: React.FC<SaleDetailsPageProps> = ({
  activeTab,
  // defaultCurrency,
  disabled,
  errors,
  // cornermarks: cornermarkChoiceList,
  // fetchCornermarks,
  // fetchMoreCornermarks,
  onRemove,
  onSubmit,
  onTabClick,
  pageInfo,
  Producttag,
  saveButtonBarState,
  onBack,
  onCategoryAssign,
  onCategoryUnassign,
  onCategoryClick,
  onCollectionAssign,
  onCollectionUnassign,
  onCollectionClick,
  onNextPage,
  onPreviousPage,
  onProductAssign,
  onProductUnassign,
  onProductClick,
  onVariantAssign,
  onVariantUnassign,
  onVariantClick,
  categoryListToolbar,
  collectionListToolbar,
  productListToolbar,
  variantListToolbar,
  isChecked,
  selected,
  toggle,
  toggleAll
  // onSaleProductAssign,
  // onSaleProductUnassign
}) => {
  const intl = useIntl();

  const initialForm: ProductTagDetailsPageFormData = {
    // endDate: splitDateTime(maybe(() => Producttag.endDate, "")).date,
    // endTime: splitDateTime(maybe(() => Producttag.endDate, "")).time,
    tagType: maybe(() => Producttag.tagType, ProductTagsTagType.TEXT),
    // hasEndDate: maybe(() => !!Producttag.endDate),
    title: maybe(() => Producttag.title, ""),
    name: maybe(() => Producttag.name, ""),
    stickersImage: maybe(() => Producttag.stickersImage, ""),
    stickersImageLocationX: maybe(() => Producttag.stickersImageLocationX, 0),
    stickersImageLocationY: maybe(() => Producttag.stickersImageLocationY, 0),
    showTag: maybe(() => Producttag.showTag, true),
    componentFontColor: maybe(() => Producttag.componentFontColor, ""),
    productFontColor: maybe(() => Producttag.productFontColor, ""),
    productBackgroundColor: maybe(() => Producttag.productBackgroundColor, "")
    // startDate: splitDateTime(maybe(() => Producttag.startDate, "")).date,
    // startTime: splitDateTime(maybe(() => Producttag.startDate, "")).time,
    // type: maybe(() => Producttag.type, SaleTypeEnum.FIXED),
    // value: maybe(() => Producttag.value.toString(), ""),
    // cornerMark: maybe(() => Producttag.cornerMark.titleText.toString(), ""),
    // products: maybe(() =>
    //   Producttag.saleProducts.edges.map(item => ({
    //     productId: item.node.product.id,
    //     usageLimit: item.node.usageLimit,
    //     discountPrice: item.node.discountPrice.toString(),
    //     sortOrder: item.node.sortOrder || null
    //   }))
    // )
  };

  // const cornermarks = maybe(() => cornermarkChoiceList, []).map(cornermark => ({
  //   label: cornermark.titleText,
  //   value: cornermark
  // }));

  // const [selectedCornermark, setSelectedCornermark] = useStateFromProps(
  //   sale?.cornerMark?.titleText || ""
  // );
  return (
    <Form initial={initialForm} onSubmit={onSubmit}>
      {({ change, data, hasChanged, setNameValue, submit }) => (
        // const handleCornerMarkSelect = createSingleAutocompleteSelectHandler(
        //   change,
        //   setSelectedCornermark,
        //   cornermarks
        // );
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.producttags)}
          </AppHeader>
          <PageHeader title={maybe(() => Producttag.name)} />
          {/* <Grid> */}
          <div>
            <ProductTagInfo
              data={data}
              disabled={disabled}
              errors={errors}
              onChange={change}
              onTabClick={onTabClick}
              setNameValue={setNameValue}
            />
            <CardSpacer />
            <TabContainer>
              <CategoriesTab
                isActive={activeTab === ProductTageDetailsPageTab.categories}
                changeTab={onTabClick}
              >
                {intl.formatMessage(
                  {
                    defaultMessage: "Categories({quantity})",
                    description: "number of categories",
                    id: "saleDetailsPageVariantsQuantity"
                  },
                  {
                    quantity: maybe(
                      () => Producttag.categories.totalCount.toString(),
                      "…"
                    )
                  }
                )}
              </CategoriesTab>
              <CollectionsTab
                isActive={activeTab === ProductTageDetailsPageTab.collections}
                changeTab={onTabClick}
              >
                {intl.formatMessage(
                  {
                    defaultMessage: "Recommendation Groups({quantity})",
                    description: "number of collections",
                    id: "saleDetailsPageVariantsQuantity"
                  },
                  {
                    quantity: maybe(
                      () => Producttag.collections.totalCount.toString(),
                      "…"
                    )
                  }
                )}
              </CollectionsTab>
              <ProductsTab
                isActive={activeTab === ProductTageDetailsPageTab.products}
                changeTab={onTabClick}
              >
                {intl.formatMessage(
                  {
                    defaultMessage: "Products ({quantity})",
                    description: "number of products",
                    id: "saleDetailsPageProductsQuantity"
                  },
                  {
                    quantity: maybe(
                      () => Producttag.products.totalCount.toString(),
                      "…"
                    )
                  }
                )}
              </ProductsTab>
              <VariantsTab
                isActive={activeTab === ProductTageDetailsPageTab.variants}
                changeTab={onTabClick}
              >
                {intl.formatMessage(
                  {
                    defaultMessage: "SKU({quantity})",
                    description: "number of skus",
                    id: "saleDetailsPageVariantsQuantity"
                  },
                  {
                    quantity: maybe(
                      () => Producttag.variants.totalCount.toString(),
                      "…"
                    )
                  }
                )}
              </VariantsTab>
            </TabContainer>
            <CardSpacer />
            {activeTab === ProductTageDetailsPageTab.categories ? (
              <DiscountCategories
                disabled={disabled}
                onCategoryAssign={onCategoryAssign}
                onCategoryUnassign={onCategoryUnassign}
                onNextPage={onNextPage}
                onPreviousPage={onPreviousPage}
                onRowClick={onCategoryClick}
                pageInfo={pageInfo}
                discount={Producttag}
                isChecked={isChecked}
                selected={selected}
                toggle={toggle}
                toggleAll={toggleAll}
                toolbar={categoryListToolbar}
              />
            ) : activeTab === ProductTageDetailsPageTab.collections ? (
              <DiscountCollections
                disabled={disabled}
                onCollectionAssign={onCollectionAssign}
                onCollectionUnassign={onCollectionUnassign}
                onNextPage={onNextPage}
                onPreviousPage={onPreviousPage}
                onRowClick={onCollectionClick}
                pageInfo={pageInfo}
                discount={Producttag}
                isChecked={isChecked}
                selected={selected}
                toggle={toggle}
                toggleAll={toggleAll}
                toolbar={collectionListToolbar}
              />
            ) : activeTab === ProductTageDetailsPageTab.products ? (
              <DiscountProducts
                disabled={disabled}
                onNextPage={onNextPage}
                onPreviousPage={onPreviousPage}
                onProductAssign={onProductAssign}
                onProductUnassign={onProductUnassign}
                onRowClick={onProductClick}
                pageInfo={pageInfo}
                discount={Producttag}
                isChecked={isChecked}
                selected={selected}
                toggle={toggle}
                toggleAll={toggleAll}
                toolbar={productListToolbar}
              />
            ) : (
              <DiscountVariants
                disabled={disabled}
                onNextPage={onNextPage}
                onPreviousPage={onPreviousPage}
                onVariantAssign={onVariantAssign}
                onVariantUnassign={onVariantUnassign}
                onRowClick={onVariantClick}
                pageInfo={pageInfo}
                discount={Producttag}
                isChecked={isChecked}
                selected={selected}
                toggle={toggle}
                toggleAll={toggleAll}
                toolbar={variantListToolbar}
              />
            )}
            <CardSpacer />
          </div>
          {/* </Grid> */}
          <SaveButtonBar
            disabled={disabled || !hasChanged}
            onCancel={onBack}
            onDelete={onRemove}
            onSave={submit}
            state={saveButtonBarState}
          />
        </Container>
      )}
    </Form>
  );
};
SaleDetailsPage.displayName = "SaleDetailsPage";
export default SaleDetailsPage;
